import React from 'react';
import './pokerCard.css';

function PokerCard({children, click}) {
  return (
    <div className='poker-card' onClick={() => click(children)}>
      <h1>
        {children}
      </h1>
    </div>
  )
}

export default PokerCard